// @flow

import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';

import { GET_HELP_CTA } from '@zapier/product-get-help';

import LoginActions from 'app/login/LoginActions';
import LoginForm from 'app/login/components/LoginForm';
import { formattedMessageForResult } from 'app/login/LoginUtils';
import { isSent } from 'app/login/submitResults';

const Description = () => (
  <span>
    <p>
      Enter the email address you signed up with below. An email will be sent
      containing a link to reset your password.
    </p>
    <p>
      Forgot which email address you signed up with?{' '}
      <a href="/app/contact-us?topic=account&account=settings&settings=reset&answer[contact]=yes">
        {_.capitalize(GET_HELP_CTA)}
      </a>
      .
    </p>
  </span>
);

const mapStateToProps = state => {
  const page = state.login.forgotPage;
  const msg = formattedMessageForResult(page.result);

  // can't submit while data in flight, and email is required
  const canSubmit = !page.isSubmitting && !!page.form.email;

  return {
    title: 'Forgot Password',
    submitText: 'Send Reset Instructions',
    shouldShowLoginForm: true,
    canSubmit,
    didSucceed: isSent(page.result),
    isSubmitting: page.isSubmitting,
    fields: [
      {
        name: 'email',
        type: 'email',
        placeholder: 'Email',
        autoFocus: true,
        value: page.form.email,
      },
    ],
    message: msg.text,
    messageType: msg.type,
    description: <Description />,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    onChange: (value, name) => {
      dispatch(LoginActions.updateForm('forgotPage', name, value));
    },
    onSubmit: fields => {
      const email = _.find(fields, { name: 'email' });
      dispatch(LoginActions.forgotPassword(email.value));
    },
  };
};

const ForgotFormContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginForm);

export default ForgotFormContainer;
